import { render } from "./AddBankInformation.vue?vue&type=template&id=2f09896c&scoped=true"
import script from "./AddBankInformation.vue?vue&type=script&lang=js"
export * from "./AddBankInformation.vue?vue&type=script&lang=js"

import "./AddBankInformation.vue?vue&type=style&index=0&id=2f09896c&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f09896c"]])

export default __exports__